import { useState } from 'react';
import { useUserProfile } from '~/services/shop/hooks';
import { useFrame, useTranslations } from '~/services/umbraco/hooks';
import { Text } from '~/shared/components/Text';
import UserProfileModal from './Modal';
import {
    FirstColumn,
    SecondColumn,
    Section,
    StyledLink,
    StyledText,
    ThirdColumn,
    UserWrapper,
} from './styled';

export default function UserInformation() {
    const { data } = useUserProfile();
    const user = data?.user;
    const { translate } = useTranslations();
    const [showOverlay, setShowOverlay] = useState(false);
    const { data: setPasswordLink } = useFrame((data) => data.mitFogSettings?.setPasswordLink?.url);

    return (
        <>
            <Section>
                <UserWrapper>
                    <FirstColumn>
                        <Text variant="display6">{translate('mit-fog.userProfile.email')}</Text>
                    </FirstColumn>
                    <SecondColumn>
                        <StyledText>{user?.email ?? '-'}</StyledText>
                    </SecondColumn>
                </UserWrapper>

                <UserWrapper>
                    <FirstColumn>
                        <Text variant="display6">{translate('mit-fog.userProfile.name')}</Text>
                    </FirstColumn>
                    <SecondColumn>
                        <Text>{user?.name ?? '-'}</Text>
                    </SecondColumn>
                    <ThirdColumn>
                        <StyledLink
                            aria-label={translate('mit-fog.userProfile.edit')}
                            as="button"
                            onClick={() => setShowOverlay(true)}
                        >
                            {translate('mit-fog.userProfile.edit')}
                        </StyledLink>
                    </ThirdColumn>
                </UserWrapper>

                <UserWrapper>
                    <FirstColumn>
                        <Text variant="display6">{translate('mit-fog.userProfile.phone')}</Text>
                    </FirstColumn>
                    <SecondColumn>
                        <Text>{user?.phoneNumber ?? '-'}</Text>
                    </SecondColumn>
                    <ThirdColumn>
                        <StyledLink
                            aria-label={translate('mit-fog.userProfile.edit')}
                            as="button"
                            onClick={() => setShowOverlay(true)}
                        >
                            {translate('mit-fog.userProfile.edit')}
                        </StyledLink>
                    </ThirdColumn>
                </UserWrapper>

                <UserWrapper>
                    <FirstColumn>
                        <Text variant="display6">{translate('mit-fog.userProfile.password')}</Text>
                    </FirstColumn>
                    <SecondColumn>
                        <Text>********</Text>
                    </SecondColumn>
                    <ThirdColumn>
                        <StyledLink href={setPasswordLink} target="_blank">
                            {translate('mit-fog.userProfile.changePassword')}
                        </StyledLink>
                    </ThirdColumn>
                </UserWrapper>
            </Section>

            <UserProfileModal setShowOverlay={setShowOverlay} showOverlay={showOverlay} />
        </>
    );
}
